export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return;
  } catch {
    // Embedded browsers may disallow async clipboard access but allow a
    // user-triggered copy from a focused input inside the current dialog.
    const previous = document.activeElement;
    const input = document.createElement('textarea');
    input.value = text;
    input.readOnly = true;
    input.setAttribute('aria-label', 'Bet ID to copy');
    input.setAttribute('data-testid', 'clipboard-copy-fallback');
    Object.assign(input.style, { position: 'fixed', left: '0', top: '0', width: '1px', height: '1px', opacity: '0' });
    const target = previous?.closest('[role="dialog"]') || document.body;
    target.appendChild(input);
    input.focus({ preventScroll: true });
    input.select();
    input.setSelectionRange(0, text.length);
    try {
      if (!document.execCommand('copy')) throw new Error('Clipboard access is unavailable');
    } finally {
      input.remove();
      previous?.focus({ preventScroll: true });
    }
  }
};